// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"833":"cff3bb32","983":"8e621c30"}[chunkId] + ".chunk.js";
};